<template>
  <div class="community-search-users">
    <button @click="basicModal = true" class="fw-500">
      <span>Colaboradores</span>
      <i class="fas fa-search"></i>
    </button>

    <b-modal v-model="basicModal" hide-header hide-footer>
      <basic-search @close="basicModal = false" @user="openUserModal" />
      <hr class="my-3" style="border-color: rgba(255, 255, 255, 0.2);" />
      <div class="text-right">
        <button
          class="btn btn-sm text-secondary fw-500 p-0"
          @click="openAdvanced"
        >
          Pesquisa avançada
        </button>
      </div>
    </b-modal>

    <b-modal v-model="advancedModal" hide-header hide-footer size="lg">
      <advanced-search @close="advancedModal = false" @user="openUserModal" />
    </b-modal>

    <b-modal v-model="userModal" hide-header hide-footer centered size="lg">
      <profile-modal :user="user" />
    </b-modal>
  </div>
</template>

<script>
import ProfileModal from "./ProfileModal";
import BasicSearch from "./BasicSearch";
import AdvancedSearch from "./AdvancedSearch";

export default {
  components: { ProfileModal, BasicSearch, AdvancedSearch },
  data() {
    return {
      basicModal: false,
      advancedModal: false,
      userModal: false,
      user: null
    };
  },
  methods: {
    openUserModal(user) {
      this.user = user;
      this.userModal = true;
    },
    openAdvanced() {
      this.basicModal = false;
      this.advancedModal = true;
    }
  }
};
</script>

<style lang="scss" scoped>
.community-search-users {
  button {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: white;
    background: transparent;
    border: none;
  }
}
</style>
